export default __webpack_public_path__ + "assets/radio_selected.75513f4d.svg";